import { use } from "react";

import { NotificationContext } from "../_context/NotificationContext";

export const useNotification = () => {
  const context = use(NotificationContext);
  if (!context) {
    throw new Error("useNotification must be used within NotificationProvider");
  }
  return context;
};
